module.exports = __webpack_public_path__ + "static/outline-21a69249c287ff17d50a6ef2df2ac238.png";